"use client";
import Form from "./form";
import LayoutWrapper from "./LayoutWrapper";
import PnrForm from "./PnrForm";

const BusSearchFormWrapper = (props) => {
  return (
    <LayoutWrapper
      pnrFormComponent={PnrForm}
      checkInFormComponent={PnrForm}
      //checkInFormComponent={CheckInForm} TODO: CheckInForm içeriği Pnr ile aynı olacağı için commentlendi.
      translationNamespace="bus"
    >
      <Form {...props} />
    </LayoutWrapper>
  );
};

export default BusSearchFormWrapper;
